const demoButton = document.getElementById('demo');

if (demoButton) {
  demoButton.addEventListener('click', () => {
    const script = document.createElement('script')
    script.src = '/index.js'

    document.body.appendChild(script)
  })
}